import { useState, useEffect } from 'react';
import axios from 'axios';
import { FileText } from 'lucide-react';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export default function CallScripts({ campaignId, callId }) {
  const [scripts, setScripts] = useState([]);
  const [selectedScript, setSelectedScript] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    if (campaignId) {
      fetchScripts();
    }
  }, [campaignId]);

  const fetchScripts = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(
        `${API_BASE}/dialer/campaigns/${campaignId}/scripts`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setScripts(response.data);
      if (response.data.length > 0) {
        setSelectedScript(response.data[0]);
      }
    } catch (error) {
      console.error('Error fetching scripts:', error);
    }
  };

  if (scripts.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg shadow p-4 space-y-3">
      <div className="flex items-center gap-2">
        <FileText className="w-5 h-5" />
        <h3 className="font-semibold">Call Script</h3>
      </div>
      
      {scripts.length > 1 && (
        <select
          value={selectedScript?.id || ''}
          onChange={(e) => {
            const script = scripts.find(s => s.id === parseInt(e.target.value));
            setSelectedScript(script);
            setCurrentStep(0);
          }}
          className="w-full border rounded px-3 py-2"
        >
          {scripts.map((script) => (
            <option key={script.id} value={script.id}>
              {script.name}
            </option>
          ))}
        </select>
      )}

      {selectedScript && (
        <div className="bg-gray-50 rounded p-4 max-h-96 overflow-y-auto">
          {selectedScript.script_type === 'linear' ? (
            <div className="whitespace-pre-wrap">{selectedScript.content}</div>
          ) : (
            <div>
              {selectedScript.branches && selectedScript.branches.length > 0 && (
                <div>
                  <p className="font-semibold mb-2">
                    Step {currentStep + 1}: {selectedScript.branches[currentStep]?.content}
                  </p>
                  {selectedScript.branches[currentStep]?.next_step_id && (
                    <button
                      onClick={() => setCurrentStep(selectedScript.branches[currentStep].next_step_id - 1)}
                      className="text-blue-600 hover:underline"
                    >
                      Next Step →
                    </button>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}


